<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
  [gridOptionsOverrides]="gridOptionsOverrides"
  [onApplyExtraViewPresetSettings]="restoreDrillFilters"
></app-data-grid>
